<template>
    <div>
        <MyJobsTray :status=status />
    </div>
</template>

<script>
    import MyJobsTray from "./MyJobsTray";
    export default {
        name: "MyJobTrayDraft",
        components:{
            MyJobsTray
        },
        props:{
            status : Number
        }
    }
</script>

<style scoped>

</style>